import { useContext } from 'react';
import styles from '../style/contact.module.css';
import contact from '../translations/contact';
import LanguageContext from '../context/language.context';
import { publicAsset } from '../utils/publicAsset';

export default function Contact() {
  const { language } = useContext(LanguageContext);
  const year = new Date().getFullYear();

  return (
    <section
      id="contact"
      className={ styles.container }
      aria-labelledby="contact-heading"
    >
      <div className={ styles.containerTitle }>
        <h1 id="contact-heading" className={ styles.title }>{contact[language].title}</h1>
        <p className={ styles.subtitle }>{contact[language].subtitle}</p>
      </div>
      <div className={ styles.containerSocial }>
        <div className={ styles.social }>
          <img src={ publicAsset('/github_gray.svg') } alt="" />
          <a href="https://github.com/feroddev" target="_blank" rel="noreferrer">
            {contact[language].githubLine}
            <strong>feroddev</strong>
          </a>
        </div>
        <div className={ styles.social }>
          <img src={ publicAsset('/linkedin_gray.svg') } alt="" />
          <a href="https://www.linkedin.com/in/feroddev/" target="_blank" rel="noreferrer">
            linkedin.com/in
            <strong>/feroddev</strong>
            /
          </a>
        </div>
        <div className={ styles.social }>
          <img src={ publicAsset('/instagram.svg') } alt="" />
          <a href="https://www.instagram.com/neath.felipe/" target="_blank" rel="noreferrer">
            @
            <strong>
              neath.felipe
            </strong>
          </a>
        </div>
        <div className={ styles.social }>
          <img src={ publicAsset('/email.svg') } alt="" />
          <a href="mailto:neath.felipe@gmail.com">
            <strong>neath.felipe</strong>
            @gmail.com
          </a>
        </div>
        <div className={ styles.social }>
          <img src={ publicAsset('/whatsapp.svg') } alt="" />
          <a href="https://api.whatsapp.com/send?phone=5531992547049" target="_blank" rel="noopener noreferrer">
            <strong>
              +55 31 99254-7049
            </strong>
          </a>
        </div>
      </div>
      <p className={ styles.copyright }>
        ©
        {' '}
        {year}
        {' '}
        Felipe Rodrigues.
        {' '}
        {contact[language].rights}
      </p>
    </section>
  );
}
